// Bridges the ESM dialog/toast helpers onto `window` so legacy classic-script
// files (layout.js, ActEaze.js, the acteaze.* page scripts) can use the same
// confirm/toast UI as the modern TS bundles instead of SweetAlert.
import { confirmDialog } from './confirmDialog';
import { showToast } from './toast';
// Side-effect import: installs the "this button is working" guard on every page,
// so a slow button shows a spinner and can't be clicked twice.
import './busyGuard';
// Side-effect import: cleans hidden characters out of text pasted from PDFs, Word
// files and web pages, in every text box on every page.
import './pasteCleaner';

declare global {
  interface Window {
    confirmDialog: typeof confirmDialog;
    showToast: typeof showToast;
  }
}

window.confirmDialog = confirmDialog;
window.showToast = showToast;
